import CustomBubble from './CustomBubble';

export default CustomBubble;
